module.exports = __webpack_public_path__ + "img/ziliaoxiazai.bfeab4ca.png";